// extracted by mini-css-extract-plugin
export default {"list":"blog-posts__list___bbEdx"};